import { Component, EventEmitter, OnInit, Input, Output, ViewChild, forwardRef } from '@angular/core';
import { Router }            from '@angular/router';
import {Message, OverlayPanel, SelectItem} from 'primeng/primeng';
import * as _ from "lodash";

import * as ent from '../../entities/index'
import * as filters from '../../filters/index'
import * as serv from '../../services/index'
import * as enums from '../../enums/index'

//components
import {EquipmentLineItemEditComponent} from '../../components/Editors/EquipmentLineItemEdit.component';

//constants
import { Constants }         from '../../constants/Constants';

//baseclasses
import { BaseGridComponent }         from '../../baseclasses/BaseGrid.component';
import { EquipmentGridComponent } from '../Equipment/EquipmentGrid.component';
import { EquipmentClassMultiSelectComponent } from '../DomainData/EquipmentClassMultiSelect.component';

@Component({
  selector: 'my-equipmentlineitem-grid',
  templateUrl: './EquipmentLineItemGrid.component.html',
  providers: [{provide: BaseGridComponent, useExisting: forwardRef(() => EquipmentLineItemGridComponent)}]
})
export class EquipmentLineItemGridComponent extends BaseGridComponent {
    lineItems: ent.EquipmentLineItem[] = [];
    selectedLineItems: ent.EquipmentLineItem[] = [];
    editedLineItem: ent.EquipmentLineItem;
    displayEquipmentDialog: boolean;
    customerNumber: string;
    userInfo: ent.UserInfo;
    equipmentGraphics: ent.EquipmentGraphics[] = [];
    equipmentClasses: ent.EquipmentClass[] = [];
    equipmentGraphicsSelectItems: SelectItem[] = [];
    requestID: number;

    @ViewChild(EquipmentLineItemEditComponent) public EquipmentLineItemEdit: EquipmentLineItemEditComponent;
    @ViewChild(EquipmentGridComponent) public EquipmentGridComponent: EquipmentGridComponent;

    @Input() public requireEquipmentGraphics: boolean;
    @Input() public requireEquipmentAssetNumber: boolean;
    @Input() public requireSerialNumber: boolean;
    @Input() public requireModel: boolean;
    @Input() public requireLocation: boolean;
    @Input() public requireCurrentLocation: boolean;
    @Input() public requireMoveToLocation: boolean;
    @Input() public requireNewCustomerNumber: boolean;
    
    @Input() public showEquipmentGraphics: boolean;
    @Input() public showEquipmentAssetNumber: boolean;
    @Input() public showSerialNumber: boolean;
    @Input() public showMaterialNumber: boolean;
    @Input() public showEquipmentClass: boolean;
    @Input() public showProcessedByRequest: boolean;
    @Input() public showModel: boolean;
    @Input() public showLocation: boolean;
    @Input() public showCurrentLocation: boolean;
    @Input() public showMoveToLocation: boolean;
    @Input() public showNewCustomerNumber: boolean;
    @Input() showCheckboxSelectorColumn: boolean;
    @Input() showRadioSelectorColumn: boolean;

    @Output() equipmentLineItemsChanged: EventEmitter<ent.EquipmentLineItem[]> = new EventEmitter();
    
    constructor(private authenticationService: serv.AuthenticationService, private domainDataService: serv.DomainDataService, 
        private equipmentService: serv.EquipmentService, private router: Router) 
    {
        super();
    }

    ngOnInit(): void {
        this.userInfo = this.authenticationService.getUserInfo();
        this.editedLineItem = new ent.EquipmentLineItem();

        this.load();
    }

    public load(){
      
        var egFilter: filters.EquipmentGraphicsFilter = {};
        this.domainDataService.getEquipmentGraphics(egFilter).subscribe(x=> {
            x.forEach(y=> this.equipmentGraphics.push(y));

            this.equipmentGraphicsSelectItems.push({label:"", value:Constants._NONE});
            x.forEach(y=> this.equipmentGraphicsSelectItems.push({label:y.Name, value:y.ID}));

        });

        this.domainDataService.getEquipmentClasses().subscribe(x=> {this.equipmentClasses = x});
    }
    
    onAddClick(event: any){
        if (!this.lineItems){this.lineItems = []}
        var newLineItem = new ent.EquipmentLineItem();
        newLineItem.EquipmentClassID = enums.EquipmentClassEnum.FountainBarGun;
        newLineItem.EquipmentClass = this.equipmentClasses.filter(x=>x.ID == newLineItem.EquipmentClassID)[0];
        newLineItem.CanEditEquipmentNumbers = true;

        this.lineItems = [...this.lineItems, newLineItem];

        this.equipmentLineItemsChanged.emit(this.lineItems);
        
    }

    disableAddButton(): boolean{
        if (this.showRadioSelectorColumn && this.lineItems.length > 0){
            return true;
        }
        return false;
    }

    onAddFromInventoryClick(event: any){
      
        this.displayEquipmentDialog = true;
        var filter: filters.EquipmentFilter = {CustomerNumber: this.customerNumber, 
            //SalesOfficeCode: this.userInfo.SalesOffice.Number, 
            IncludeRelatedEquipmentRequests: true, RequestID: this.requestID};
        this.EquipmentGridComponent.load(filter, []);
    }

    disableAddEquipmentFromInventoryOK(): boolean {
        return this.EquipmentGridComponent.selectedRecords.length == 0;
    }

    onAddEquipmentFromInventoryOKClick(event: any){
        this.displayEquipmentDialog = false;
        
        _.remove(this.lineItems, x=>!x.CanEditEquipmentNumbers);
        
        if (this.EquipmentGridComponent.showCheckboxSelectorColumn){
            for (var rec of this.EquipmentGridComponent.selectedRecords){
                this.createEquipmentLineItemRecord(rec);
            }
        }
        else if (this.EquipmentGridComponent.showRadioSelectorColumn){
            this.createEquipmentLineItemRecord(this.EquipmentGridComponent.selectedRecord);
        }

        this.equipmentLineItemsChanged.emit(this.lineItems);
    }

    createEquipmentLineItemRecord(rec: ent.Equipment) : void {
        var lineItem: ent.EquipmentLineItem = {
            EquipmentClassID: rec.EquipmentTypeClassXref.EquipmentClassID,
            EquipmentClass: rec.EquipmentTypeClassXref.EquipmentClass,
            EquipmentAssetNumber: rec.EquipmentNumber,
            SerialNumber: rec.SerialNumber,
            MaterialNumber: rec.MaterialNumber,
            Model: rec.ModelGroup,
            EquipmentGraphicsID: rec.EquipmentGraphicsID,
            EquipmentGraphics: rec.EquipmentGraphics,
            Location: "",
            CurrentLocation: "",
            MoveToLocation: "",
            NewCustomerNumber: "",
            CanEditEquipmentNumbers: false
        };
        this.lineItems.push(lineItem);
    }

    disableAddFromInventory() : boolean {
        if (this.customerNumber === undefined || this.customerNumber == ""){
            return true;
        }
        if (this.userInfo.SalesOffice.Number === undefined || this.userInfo.SalesOffice.Number == ""){
            return true;
        }
        return false;
    }

    onDeleteClick(event: any, lineItem: ent.EquipmentLineItem){
        this.lineItems = _.remove(this.lineItems, x=>x !== lineItem);
        this.equipmentLineItemsChanged.emit(this.lineItems);
    }
    

    onEditClick(event: any, lineItem: ent.EquipmentLineItem){
        
        this.editedLineItem = lineItem;
        this.EquipmentLineItemEdit.lineItem = lineItem;
        this.EquipmentLineItemEdit.equipmentGraphicsDropdown.value = this.editedLineItem.EquipmentGraphicsID;
        this.EquipmentLineItemEdit.displayDialog = true;

        if (this.EquipmentLineItemEdit.equipmentsAutoCompleteComponent){
            this.EquipmentLineItemEdit.equipmentsAutoCompleteComponent.equipments = [];
            this.EquipmentLineItemEdit.equipmentsAutoCompleteComponent.selectedEquipmentNumbers = [];
            if (this.EquipmentLineItemEdit.equipmentsAutoCompleteComponent.multiple){
                
            }
            else{
                // var filter: filters.EquipmentFilter = {EquipmentNumber: lineItem.EquipmentAssetNumber};
                // this.equipmentService.getEquipments(filter).then(x=>
                // {
                //     if (x && x.length > 0){
                //         var equip = x[0];
                //         this.EquipmentLineItemEdit.equipmentsAutoCompleteComponent.equipmentsModel = {name: equip.FullName, ID: equip.EquipmentNumber};
                //     }
                    
                // });
            }
        }
       
    }

    

    onEquipmentLineItemEditOK(){
        
        var equipmentGraphics = this.equipmentGraphics.filter(x=>x.ID == this.editedLineItem.EquipmentGraphicsID)[0];
        this.editedLineItem.EquipmentGraphics = {ID: equipmentGraphics.ID, Name: equipmentGraphics.Name, Code: "", Inactive: equipmentGraphics.Inactive};

        this.lineItems = <ent.EquipmentLineItem[]>this.addLineItem(this.editedLineItem, this.lineItems);
    }

    equipmentGraphicsChange(event: any, lineItem: ent.EquipmentLineItem){
        var eg = this.equipmentGraphics.filter(x=>x.ID == event)[0];
        if (!lineItem.EquipmentGraphics || lineItem.EquipmentGraphics.ID != eg.ID){
            lineItem.EquipmentGraphics = eg;
            lineItem.EquipmentGraphicsID = eg.ID;
        }
    
    }

    onHide(){
        this.displayEquipmentDialog = false;
    }

}